import {gql} from '@apollo/client';

export const GET_RECURRING_INVESTMENTS = gql`
  query GetRecurringInvestments($filter: RecurringInvestmentFilter!) {
    getRecurringInvestments(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithRecurringInvestments {
        pagination {
          total
        }
        data {
          user {
            firstName
            lastName
            imageUrl
            email
            id
          }
          status
          id
          currency
          amount
          symbol
          createdAt
          successfulPaymentCycles
          failedPaymentCycles
          nextRunDate
          frequency
          company {
            ticker
          }
          assetType
        }
      }
    }
  }
`;

export const GET_RECURRING_INVESTMENT_STATS = gql`
  query GetRecurringInvestmentStatistics {
    getRecurringInvestmentStatistics {
      ... on ResponseWithRecurringInvestmentStatistics {
        message
        data {
          totalAmount
          totalActiveAmount
          totalInactiveAmount
          totalActiveCount
          totalInactiveCount
          assetType
        }
      }
      ... on Error {
        message
        type
      }
    }
  }
`;

export const GET_USER_RECURRING_INVESTMENTS_STATS = gql`
  query GetRecurringInvestmentStatistics($userId: ID) {
    getRecurringInvestmentStatistics(userId: $userId) {
      ... on ResponseWithRecurringInvestmentStatistics {
        message
        data {
          totalAmount
          assetType
          totalActiveAmount
          totalInactiveAmount
          totalActiveCount
          totalInactiveCount
        }
      }
      ... on Error {
        message
        type
      }
    }
  }
`;

export const GET_RECURRING_INVESTMENT_LOGS = gql`
  query GetRecurringInvestmentLogs($filter: RecurringInvestmentLogFilter!) {
    getRecurringInvestmentLogs(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithRecurringInvestmentLogs {
        pagination {
          total
        }
        data {
          status
          reason
          processedAmount
          amountDifference
          order {
            expiresAt
            company {
              ticker
              stock {
                lastPrice
              }
            }
            direction
            collection {
              name
              bannerUrl
            }
            createdAt
            broker {
              id
              name
            }
            brokerOrderId
            updatedAt
            brokerIds
            instrumentKey
            symbol
            hold
            expiresAt
            settlementDate
            limitPrice
            lastFillDate
            staticFee
            floatingFee
            entryFee
            commissionFee
            exitFee
            totalFee
            recurringFee
            feeCharged
            feeCharged
            avgFillPrice
            feeSchedule {
              feeName
              feeType
              fixedFeeAmount
              variableFeeAmount
            }
            type
            notes {
              id
              note
              createdAt
              createdById
              createdBy {
                email
                firstName
                lastName
              }
              updatedAt
              updatedById
              updatedBy {
                email
                firstName
                lastName
              }
            }
            fillQuantity
            type
            price
            quantity
            status
            assetCurrency
            userId
            id
          }
          currency
          amountDifference
        }
      }
    }
  }
`;

export const CHANGE_RECURRING_INVESTMENT_STATUS = gql`
  mutation ChangeRecurringInvestmentState(
    $changeRecurringInvestmentStateId: ID!
    $state: RecurringInvestmentState!
  ) {
    changeRecurringInvestmentState(
      id: $changeRecurringInvestmentStateId
      state: $state
    ) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithRecurringInvestment {
        message
      }
    }
  }
`;
